import React from 'react';
import { Link } from 'react-router-dom';

import { Button, H1 } from '@eluve/components';

export const ErrorPage: React.FC<{ reset?: () => void }> = ({ reset }) => {
  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-text-accent-primary">
          Error
        </p>
        <H1 xl m="mt-4">
          We're sorry
        </H1>
        <p className="mt-6 text-base leading-7 text-text-tertiary">
          It seems like something went wrong. The team has been notified and
          we're working on fixing it.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Button variant={'outline'} onClick={reset}>
            Try again
          </Button>
          <Link
            to="/"
            className="rounded-md bg-bg-accent-strong-secondary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-bg-accent-strong-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-accent-quaternary"
            onClick={reset}
          >
            Go back home
          </Link>
        </div>
      </div>
    </main>
  );
};
